<template>
    <default-item class="menu--item-wv_steak_house_signature_drink" :item="item" layout="price-inline"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for WV Steak House signature drink items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - <WvSteakHouseCocktailItem> copied to <WvSteakHouseSignatureDrinkItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <WvSteakHouseSignatureDrinkItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'WVSteakHouseSignatureDrinkItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
})
</script>

<style scoped>
.visual_menu--section .menu--item.menu--item-wv_steak_house_signature_drink {
  grid-template-columns: 1fr;
}

.menu--item-wv_steak_house_signature_drink + .menu--item-wv_steak_house_signature_drink {
  margin-top: 2em;
}

.menu--item-wv_steak_house_signature_drink:deep(.menu--item_price) {
  float: right;
}

.menu--item-wv_steak_house_signature_drink:deep(.menu--item_description) {
  text-align: justify;
}
</style>